import {
  fetchGetInfiniteSearchResultDesktop,
  type TGetInfiniteSearchResultDesktopRequest,
} from 'shared/repositories/search-offers/v3/get-infinite-search-result-desktop';
import {
  fetchGetOffersByIdsDesktop,
  type TGetOffersByIdsDesktopResponse,
} from 'shared/repositories/search-offers/v1/get-offers-by-ids-desktop';

import { HttpBadStatusCodeError } from '@cian/peperrors/shared';

import type { IJsonQuery } from '../json_query';
import type { IOffer } from '../offer';
import type { IHttpApi } from '@cian/http-api/shared';
import type { IInfiniteSearchResultSchema } from 'shared/repositories/search-offers/entities/infinite_search_result/InfiniteSearchResultSchema';
import type { IMgetOffersByIdsResponseSchema } from 'shared/repositories/search-offers/entities/schemas/MgetOffersByIdsResponseSchema';

export interface IQsToUris {
  [key: string]: string;
}

interface IGetOffersResponse {
  offersSerialized: IOffer[];
  qsToUris: IQsToUris;
}

export interface IInfiniteSearchResult {
  itemId: number;
  modelVersion: string;
  score: number;
}

export interface IOffersMLResponse {
  offersSerialized: IOffer[];
  qsToUris: IQsToUris;
}

export const getOffers = async (
  httpApi: IHttpApi,
  cianOfferIds: number[],
  jsonQuery: IJsonQuery,
  liquiditySource: string | null,
): Promise<IGetOffersResponse> => {
  const { response }: TGetOffersByIdsDesktopResponse = await fetchGetOffersByIdsDesktop({
    httpApi,
    parameters: {
      cianOfferIds,
      jsonQuery,
      ...(liquiditySource ? { liquiditySource } : undefined),
    },
  });

  const { offersSerialized, qsToUris } = response as IMgetOffersByIdsResponseSchema;

  return {
    offersSerialized: offersSerialized as IOffer[],
    qsToUris: qsToUris as IQsToUris,
  };
};

export const getSuggestionIds = async (
  httpApi: IHttpApi,
  parameters: TGetInfiniteSearchResultDesktopRequest,
): Promise<IInfiniteSearchResultSchema[]> => {
  const result = await fetchGetInfiniteSearchResultDesktop<never, never>({
    httpApi,
    parameters,
  });

  if (result.statusCode === 400) {
    const { errors, message } = result.response;

    throw new HttpBadStatusCodeError({
      domain: 'shared.api.offers.getSuggestionIds',
      message: message ?? 'Не удалось получить рекомендации бесконечной выдачи',
      statusCode: result.statusCode,
      details: errors ? { errors: errors.map(error => JSON.stringify(error)) } : undefined,
    });
  }

  return result.response.infiniteSearchResult;
};
